import {Component, DestroyRef, OnInit, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {EventsManager} from 'src/app/services/events.manager';
import {PlansService} from 'src/app/services/plans.service';
import {GetDocumentDetailRequestInterface} from 'src/app/interfaces/document-request.interface';
import {PhonePipe} from 'src/app/pipes/phone.pipe';
import {ActivatedRoute, RouterLink} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {NgIf, NgFor} from '@angular/common';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  imports: [NgIf, FormsModule, NgFor, RouterLink, PhonePipe]
})

export class SupportComponent implements OnInit {
  private _plansService = inject(PlansService);
  private _activatedRoute = inject(ActivatedRoute);
  private _destroyRef = inject(DestroyRef);

  public eventsManager = inject(EventsManager);

  public plans: any = {};
  public currentYear: number = 2025;
  public prevFeeUrl: string = '';
  public prevDiscountUrl: string = '';
  public currFeeUrl: string = '';
  public currDiscountUrl: string = '';
  public stateChosen: boolean = false;
  public currentState: any = {};
  public selectedState: string = '';
  public stateAbbr: string = '';
  public info: any = {};
  public showIfPurchaseIsNotAdha: boolean = false;
  public previousPrefixText: string = '';
  public currentPrefixText: string = '';

  public ngOnInit(): void {
    this.plans = this.eventsManager.getOfficeInfo();

    this.info = this.eventsManager.contactInfo;
    this.eventsManager.contactInfoUpdated.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(() => {
      this.info = this.eventsManager.contactInfo;
    });
    if (this.eventsManager.purchaseIsADHA) {
      this.stateAbbr = 'ADHA';
    }
    const url: string = this._activatedRoute.snapshot.url.join('|');
    if (url.includes('adha')) {
      this.stateAbbr = 'ADHA';
      this.stateChosen = true;
      this.eventsManager.purchaseIsADHA = true;
      this.showIfPurchaseIsNotAdha = true;
      this.eventsManager.setHideHeader(true);
      this.getPlanDocuments();
    }

    this.previousPrefixText = (this.currentYear-1).toString();
    this.currentPrefixText = this.currentYear.toString();
    if (this.showIfPurchaseIsNotAdha) {
      this.currentPrefixText = 'ADHA';
    }

    if (sessionStorage['state'] && !this.showIfPurchaseIsNotAdha) {
      this.currentState = JSON.parse(sessionStorage['state']);
      this.selectedState = this.currentState.name;
      this.stateAbbr = this.currentState.abbr;
      this.stateChosen = true;
      this.getPlanDocuments();
    }
  }

  public stateChanged(state: any) {
    if (state.target.value !== 'none') {
      this.stateAbbr = state.target.value;
      this.stateChosen = true;
      state.target.blur();
      this.getPlanDocuments();
    } else {
      this.stateChosen = false;
    }
  }

  public openUrl(url: string) {
    switch (url) {
      case 'prevFees':
        window.open(this.prevFeeUrl);
        break;
      case 'prevDiscount':
        window.open(this.prevDiscountUrl);
        break;
      case 'currFees':
        window.open(this.currFeeUrl);
        break;
      case 'currDiscount':
        window.open(this.currDiscountUrl);
        break;
    }
  }

  public getPlanDocuments() {
    if (!this.showIfPurchaseIsNotAdha) {
      const docReq: GetDocumentDetailRequestInterface = {category:'PlanDetails,MembershipAgreements', brand:'sgdp', year:(this.currentYear-1).toString(), organizationId:this.eventsManager.orgId, coverageLevelName:'', planName:'', state:this.stateAbbr};
      this._plansService.getDocumentDetails(docReq).pipe(takeUntilDestroyed(this._destroyRef)).subscribe(
        (response) => {
          const urls = response.split(',');
          this.prevFeeUrl = urls[1];
          this.prevDiscountUrl = urls[0];
        }
      );
      const docReq2: GetDocumentDetailRequestInterface = {category:'PlanDetails,MembershipAgreements', brand:'sgdp', year:(this.currentYear).toString(), organizationId:this.eventsManager.orgId, coverageLevelName:'', planName:'', state:this.stateAbbr};
      this._plansService.getDocumentDetails(docReq2).pipe(takeUntilDestroyed(this._destroyRef)).subscribe(
        (response) => {
          const urls = response.split(',');
          this.currFeeUrl = urls[1];
          this.currDiscountUrl = urls[0];
        }
      );
    } else {
      const docReq: GetDocumentDetailRequestInterface = {category:'PlanDetails,MembershipAgreements', brand:'sgdp', year:(this.currentYear).toString(), organizationId:this.eventsManager.orgId, coverageLevelName:'', planName:'', state:'ADHA'};
      this._plansService.getDocumentDetails(docReq).pipe(takeUntilDestroyed(this._destroyRef)).subscribe(
        (response) => {
          const urls = response.split(',');
          this.currFeeUrl = urls[1];
          this.currDiscountUrl = urls[0];
        }
      );
    }
  }
}
